import type { Role } from './use-me'

export const isAdmin = (r?: Role): boolean => r === 'admin'
export const isClevel = (r?: Role): boolean => r === 'clevel'

/** Editing reference/settings data (orgs, accounts, categories, …) — owner only. */
export const canEditSettings = (r?: Role): boolean => r === 'admin'

/** Deleting any entity — owner only. */
export const canDelete = (r?: Role): boolean => r === 'admin'

/** Viewing Прогноз / Кэшфлоу / Ліцензії — clevel and above. */
export const canViewExecutive = (r?: Role): boolean => r === 'admin' || r === 'clevel'

/** Creating/updating operational data — any authenticated role. */
export const canEditOperational = (r?: Role): boolean =>
  r === 'admin' || r === 'clevel' || r === 'user'

export const roleLabel = (r?: Role): string =>
  r === 'admin' ? 'Owner' : r === 'clevel' ? 'C-level' : 'Користувач'
